import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["PQIndex"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postPqIndexGetMeasuringPointTime: build.query<
        PostPqIndexGetMeasuringPointTimeApiResponse,
        PostPqIndexGetMeasuringPointTimeApiArg
      >({
        query: (queryArg) => ({
          url: `/PQIndex/GetMeasuringPointTime`,
          method: "POST",
          body: queryArg.pqIndexRequestDto,
          params: { groupBySubstation: queryArg.groupBySubstation },
        }),
        providesTags: ["PQIndex"],
      }),
      postPqIndexGetMeasuringPointDataField: build.query<
        PostPqIndexGetMeasuringPointDataFieldApiResponse,
        PostPqIndexGetMeasuringPointDataFieldApiArg
      >({
        query: (queryArg) => ({
          url: `/PQIndex/GetMeasuringPointDataField`,
          method: "POST",
          body: queryArg.pqIndexRequestDto,
          params: {
            groupBySubstation: queryArg.groupBySubstation,
            groupByCategory: queryArg.groupByCategory,
          },
        }),
        providesTags: ["PQIndex"],
      }),
      postPqIndexGet: build.query<
        PostPqIndexGetApiResponse,
        PostPqIndexGetApiArg
      >({
        query: (queryArg) => ({
          url: `/PQIndex/Get`,
          method: "POST",
          body: queryArg.pqIndexRequestDto,
          params: {
            row: queryArg.row,
            column: queryArg.column,
            groupBySubstation: queryArg.groupBySubstation,
            groupByCategory: queryArg.groupByCategory,
          },
        }),
        providesTags: ["PQIndex"],
      }),
      postPqIndexGetDataFieldTime: build.query<
        PostPqIndexGetDataFieldTimeApiResponse,
        PostPqIndexGetDataFieldTimeApiArg
      >({
        query: (queryArg) => ({
          url: `/PQIndex/GetDataFieldTime`,
          method: "POST",
          body: queryArg.pqIndexRequestDto,
          params: { groupByCategory: queryArg.groupByCategory },
        }),
        providesTags: ["PQIndex"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as pqIndexApi };
export type PostPqIndexGetMeasuringPointTimeApiResponse =
  /** status 200 OK */ CellValueDto[][];
export type PostPqIndexGetMeasuringPointTimeApiArg = {
  groupBySubstation?: boolean;
  pqIndexRequestDto: PqIndexRequestDto;
};
export type PostPqIndexGetMeasuringPointDataFieldApiResponse =
  /** status 200 OK */ CellValueDto[][];
export type PostPqIndexGetMeasuringPointDataFieldApiArg = {
  groupBySubstation?: boolean;
  groupByCategory?: boolean;
  pqIndexRequestDto: PqIndexRequestDto;
};
export type PostPqIndexGetApiResponse = /** status 200 OK */ CellValueDto[][];
export type PostPqIndexGetApiArg = {
  row?: PqIndexDimension;
  column?: PqIndexDimension;
  groupBySubstation?: boolean;
  groupByCategory?: boolean;
  pqIndexRequestDto: PqIndexRequestDto;
};
export type PostPqIndexGetDataFieldTimeApiResponse =
  /** status 200 OK */ CellValueDto[][];
export type PostPqIndexGetDataFieldTimeApiArg = {
  groupByCategory?: boolean;
  pqIndexRequestDto: PqIndexRequestDto;
};
export type CellValueDto = {
  row: string;
  col: string;
  value?: number | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type PqIndexRequestDto = {
  start: string;
  end: string;
  dataFieldIds?: number[] | null;
  measuringPointNames?: string[] | null;
  pqIndexMinimum?: number;
  pqIndexMaximum?: number;
  thresholdStandard?: string | null;
};
export type PqIndexDimension = "MeasuringPoints" | "DataFields" | "Time";
export const {
  usePostPqIndexGetMeasuringPointTimeQuery,
  useLazyPostPqIndexGetMeasuringPointTimeQuery,
  usePostPqIndexGetMeasuringPointDataFieldQuery,
  useLazyPostPqIndexGetMeasuringPointDataFieldQuery,
  usePostPqIndexGetQuery,
  useLazyPostPqIndexGetQuery,
  usePostPqIndexGetDataFieldTimeQuery,
  useLazyPostPqIndexGetDataFieldTimeQuery,
} = injectedRtkApi;
